<template>
    <div class="text-center" v-if="!is_data_ready">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div class="tab-pane fade show active text-center" v-else-if="matchCommentary.length === 0">
        <p>{{$t('football.match-detail.No Commentary found')}}</p>
    </div>
    <div class="tab-pane active" id="commentary" style="background: white;"  v-else>
        <div class="commentary_list_wrap">
            <ul id="commentary_list_ul">
                <li class="ftb_details_commentary_section clearfix" v-for="commentary in matchCommentary" :key="commentary.id">
                    <div class="ftb_details_commentary_box">
                        <div class="ftb_details_commentary_pic" v-if="commentary.mediaImage">
                          <span>
                              <img :src="commentary.mediaImage" alt="MediaImage" loading="lazy">
                          </span>
                        </div>
                        <div class="ftb_details_commentary_desc">
                            <div class="ftb_details_commentary_desc_row">
                             <h2 v-if="commentary.commentText == 'Half Time' || commentary.commentText == 'HT' || commentary.commentText == 'End of First Half' " >HT</h2>
                             <h2 v-if="commentary.commentText == 'Full Time' || commentary.commentText == 'FT' || commentary.commentText == 'End of Second Half' " >FT</h2>
                              <div class="ftb_details_commentary_desc_personal">
                                    <div class="ftb_commentary_time_status_col">
                                       <p>{{commentary.minute}}'</p>
                                    </div>
                                        <div class="ftb_commentary_title_details_col">
                                            <h3>{{heading}}</h3>
                                        </div>
                                </div>
                                <div class="ftb_details_commentary_desc_personal">
                                    <div class="ftb_commentary_time_status_col">
                                        <a v-if="commentary.commentText == 'Info'" class="pic_area" target="_blank" href="javascript:;"> <img :src="require('@/assets/images/football/info.png')" alt="Info" loading="lazy"></a>
                                        <a v-else-if="commentary.commentText == 'Yellow Card'" class="pic_area" target="_blank" href="javascript:;"> <img :src="require('@/assets/images/football/114.png')" alt="Yellow Card" loading="lazy"></a>
                                        <a v-else-if="commentary.commentText == 'Red Card'" class="pic_area" target="_blank" href="javascript:;"> <img :src="require('@/assets/images/football/115.png')" alt="Red Card" loading="lazy"></a>
                                        <a v-else class="pic_area" target="_blank" href="javascript:;"> <img :src="require('@/assets/images/football/twitterX.png')" alt="Twitter" loading="lazy"></a>
                                        
                                    </div>
                                    <div class="ftb_commentary_title_details_col">
                                        <a :href="commentary.authorPageUrl" class="commentary_desc_logo" target="_blank"
                                          v-if="commentary.authorPageUrl">
                                            <img :src="commentary.authorProfileImage" alt="twitter" loading="lazy">
                                        </a>
                                        <p v-html="decodeHtml(commentary.comment)"></p>
                                    </div>
                                </div>
                                <!-- <div class="ftb_details_commentary_social_feedback">
                                    <div class="ftb_details_commentary_feedback_col">
                                        <ul>
                                            <li>
                                                <a @click="likePost(commentary.id)" href="javascript:;">{{commentary.likes}}<i
                                                        :class="findPost(postIds,commentary.id,false,'dislike')?'post_selected' : ''"
                                                        class="fa fa-thumbs-up"></i></a>
                                            </li>
                                            <li>
                                                <a @click="dislikePost(commentary.id)" href="javascript:;">{{commentary.dislikes}}<i
                                                        :class="findPost(postIds,commentary.id,false,'like')?'post_selected' : ''"
                                                        class="fa fa-thumbs-down"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="ftb_details_commentary_social_col">
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank"><i
                                                        class="fa fa-facebook"></i></a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank"><i
                                                        class="fa fa-twitter"></i></a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank"><i
                                                        class="fa fa-reply"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    const STORAGE_KEY = '_fb_commentary_like';
    export default {
        name: "MatchDetailCommentary",
        metaInfo() {
            let ss = this.$store.state.siteSetting;
            if(this.$store.state.rugbyMatchDetailResponse.data && this.$store.state.rugbyMatchDetailResponse.data.competitors){
                var replacements = {
                    '%HOME_TEAM%': this.$filterTeam(this.$store.state.rugbyMatchDetailResponse.data.competitors, true).name,
                    '%AWAY_TEAM%': this.$filterTeam(this.$store.state.rugbyMatchDetailResponse.data.competitors, false).name,
                    '%DATE%': this.$route.params.date,
                };
            }

            let title = this.$getSafe(() => this.$replacePlaceHolders(ss.rugby_match_commentary_meta_title,replacements));
            let description = this.$getSafe(() => this.$replacePlaceHolders(ss.rugby_match_commentary_meta_description,replacements));
            let keywords = this.$getSafe(() => ss.rugby_match_commentary_meta_keywords);

            return {
                title: title,
                description: description,
                meta: this.$getMetaTags(title, description, keywords),
                link: [
                    {rel: 'canonical', href: this.$toFullPath(this.$route.fullPath)}],
            };
        },
        data() {
            return {
                matchCommentary: {},
                heading: '',
                postIds: []
            };
        },
        mounted() {
            this.postIds = this.$store.getters.fbLikeCommentary;
            this.getCommentary();
        },
        serverPrefetch() {
            return this.getCommentary();
        },
        methods: {
            getCommentary() {
                this.is_data_ready = false;

                return this.$axios
                    .get(this.$RUGBY_MATCH_COMMENTARY_API.replace(':match', this.$route.params.matchId))
                    .then(response => {
                        this.matchCommentary = response.data.commentary;
                        this.heading = response.data.heading;
                        this.is_data_ready = true;

                    })
                    .catch(error => console.log(error))
            },
            decodeHtml(html) {
                if (isBrowser) {
                    var txt = document.createElement("textarea");
                    txt.innerHTML = html;
                    return txt.value;
                }
            },
            likePost(post_id) {

                var check = this.findPost(this.postIds, post_id, true, 'dislike');
                if (check == 0) {
                    var params = {post_id: post_id, type: 'like', subtype: 'add'};
                    this.$axios
                        .get(this.$FB_COMMENTARY_LIKES_API, {params})
                        .then(response => {
                            this.setPostLikesDislike(post_id, response.data);
                            this.postIds.push({
                                'post_id': post_id,
                                'like': 1,
                                'dislike': 2,
                            });
                            this.$store.commit('addFbLikeCommentary', JSON.stringify(this.postIds))
                        })
                        .catch(error => console.log(error))
                } else {
                    if (check == 1) {
                        var params = {post_id: post_id, type: 'like', subtype: 'add_remove'};
                        this.$axios
                            .get(this.$FB_COMMENTARY_LIKES_API, {params})
                            .then(response => {
                                this.setPostLikesDislike(post_id, response.data);
                                this.postIds.push({
                                    'post_id': post_id,
                                    'like': 1,
                                    'dislike': 2,
                                });
                                this.$store.commit('addFbLikeCommentary', JSON.stringify(this.postIds))

                            })
                            .catch(error => console.log(error))
                    } else if (check == 2) {
                        var params = {post_id: post_id, type: 'like', subtype: 'remove'};
                        this.$axios
                            .get(this.$FB_COMMENTARY_LIKES_API, {params})
                            .then(response => {
                                this.setPostLikesDislike(post_id, response.data);
                            })
                            .catch(error => console.log(error));
                    }
                }
            },
            dislikePost(post_id) {
                var check = this.findPost(this.postIds, post_id, true, 'like');
                if (check == 0) {
                    var params = {post_id: post_id, type: 'dislike', subtype: 'add'};
                    this.$axios
                        .get(this.$FB_COMMENTARY_LIKES_API, {params})
                        .then(response => {
                            this.setPostLikesDislike(post_id, response.data);
                            this.postIds.push({
                                'post_id': post_id,
                                'like': 2,
                                'dislike': 1,
                            });
                            this.$store.commit('addFbLikeCommentary', JSON.stringify(this.postIds))

                        })
                        .catch(error => console.log(error))
                } else {
                    if (check == 1) {
                        var params = {post_id: post_id, type: 'dislike', subtype: 'add_remove'};
                        this.$axios
                            .get(this.$FB_COMMENTARY_LIKES_API, {params})
                            .then(response => {
                                this.setPostLikesDislike(post_id, response.data);
                                this.postIds.push({
                                    'post_id': post_id,
                                    'like': 2,
                                    'dislike': 1,
                                });
                                this.$store.commit('addFbLikeCommentary', JSON.stringify(this.postIds))

                            })
                            .catch(error => console.log(error))
                    } else if (check == 2) {
                        var params = {post_id: post_id, type: 'dislike', subtype: 'remove'};
                        this.$axios
                            .get(this.$FB_COMMENTARY_LIKES_API, {params})
                            .then(response => {
                                this.setPostLikesDislike(post_id, response.data);
                            })
                            .catch(error => console.log(error));
                    }
                }
            },
            setPostLikesDislike(post_id, data) {
                var BreakException = {};
                try {
                    this.matchCommentary.forEach(function (obj) {
                        if (obj.id == post_id) {
                            obj.likes = data.result.likes;
                            obj.dislikes = data.result.dislikes;
                            throw BreakException;
                        }
                    })
                } catch (e) {
                    if (e !== BreakException) throw e;
                }
            },
            findPost(Ids, post_id, check, reaction) {
                var flag = 0;
                if (reaction == 'like') {
                    flag = 2;
                } else if (reaction == 'dislike') {
                    flag = 2;
                }
                for (var i = 0, len = Ids.length; i < len; i++) {
                    if (check) {
                        if (Ids[i].post_id === post_id) {
                            var r_flag = Ids[i][reaction];
                            Ids.splice(i, 1);
                            this.$store.commit('addFbLikeCommentary', JSON.stringify(Ids))

                            return r_flag;
                        }
                    } else {
                        if (Ids[i].post_id === post_id && flag == Ids[i][reaction]) {
                            return true;
                        }
                    }
                }
                return false;
            }
        }
    };
</script>
